// @flow
import React from "react";

const ContentInnerWrapper = (props: any) => {
    return <div className="m-content pt-3">
        {props.children}
    </div>
};

export default ContentInnerWrapper;